import { useEffect, useState } from "react";
import { drawerBeside, MOBILE } from "@/lib/jobs";

/** The wide screen, as Tailwind's `md:` reads it: 761 px and up. */
const DESKTOP = "(min-width: 761px)";

function desktopNow(): boolean {
    return (
        typeof window !== "undefined" &&
        typeof window.matchMedia === "function" &&
        window.matchMedia(DESKTOP).matches
    );
}

/** Whether the viewport is the wide screen, following it as it changes. */
export function useDesktop(): boolean {
    const [desktop, setDesktop] = useState(desktopNow);
    useEffect(() => {
        if (typeof window.matchMedia !== "function") return;
        const query = window.matchMedia(DESKTOP);
        const change = () => setDesktop(query.matches);
        change();
        query.addEventListener?.("change", change);
        return () => query.removeEventListener?.("change", change);
    }, []);
    return desktop;
}

/** Whether there is a drawer beside the list, following the viewport as it changes. */
export function useDrawerBeside(): boolean {
    const [beside, setBeside] = useState(drawerBeside);
    useEffect(() => {
        if (typeof window.matchMedia !== "function") return;
        const query = window.matchMedia(MOBILE);
        const change = () => setBeside(!query.matches);
        change();
        query.addEventListener?.("change", change);
        return () => query.removeEventListener?.("change", change);
    }, []);
    return beside;
}
